<template>
  <div class="effects">
    <div class="g-group">
      <div class="f-group">
        <div class="inner">
          <!-- <div class="text">动作特效</div> -->
          <div class="list">
            <div
              :class="isblinkEntity ? 'selected' : ''"
              @click="baseDraw('blinkEntity')"
              class="item"
            >
              <div class="logo"><svg-icon class="icon" icon-class="p-point" /></div>
              <div class="title">闪烁</div>
            </div>
            <div
              :class="isgrowEntity ? 'selected' : ''"
              @click="baseDraw('growEntity')"
              class="item"
            >
              <div class="logo"><svg-icon class="icon" icon-class="p-billboard" /></div>
              <div class="title">生长</div>
            </div>

            <div
              :class="iscomRoam ? 'selected' : ''"
              @click="baseDraw('comRoam')"
              class="item"
            >
              <div class="logo"><svg-icon class="icon" icon-class="p-billboard" /></div>
              <div class="title">漫游</div>
            </div>

            <div
              :class="iscomHide ? 'selected' : ''"
              @click="baseDraw('comHide')"
              class="item"
            >
              <div class="logo"><svg-icon class="icon" icon-class="p-billboard" /></div>
              <div class="title">隐藏</div>
            </div>

            <div
              :class="isspreadEntity ? 'selected' : ''"
              @click="baseDraw('spreadEntity')"
              class="item"
            >
              <div class="logo"><svg-icon class="icon" icon-class="p-billboard" /></div>
              <div class="title">蔓延</div>
            </div>

            <div
              :class="ismultiRoam ? 'selected' : ''"
              @click="baseDraw('multiRoam')"
              class="item"
            >
              <div class="logo"><svg-icon class="icon" icon-class="p-billboard" /></div>
              <div class="title">多漫游</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import blinkEntity from "./blinkEntity.vue";
import growEntity from "./growEntity.vue";
import comRoam from "./com-roam.vue";
import comHide from "./comHide.vue";
import spreadEntity from "./spreadEntity.vue";
import multiRoam from "./multiRoam.vue";
export default {
  props: ["subData"],
  data() {
    return {};
  },
  computed: {
    isblinkEntity() {
      var subData = this.subData;
      return subData && subData.params && subData.params.type == "blinkEntity";
    },
    isgrowEntity() {
      var subData = this.subData;
      return subData && subData.params && subData.params.type == "growEntity";
    },
    iscomRoam() {
      var subData = this.subData;
      return subData && subData.params && subData.params.type == "comRoam";
    },
    iscomHide() {
      var subData = this.subData;
      return subData && subData.params && subData.params.type == "comHide";
    },
    isspreadEntity() {
      var subData = this.subData;
      return subData && subData.params && subData.params.type == "spreadEntity";
    },

    ismultiRoam() {
      var subData = this.subData;
      return subData && subData.params && subData.params.type == "multiRoam";
    },
  },
  mounted() {
    console.log(this.subData);
  },

  beforeDestroy() {},

  methods: {
    baseDraw(type) {
      this.$parent.close();
      if (type == "blinkEntity") {
        this.open_blinkEntity();
        return;
      }

      if (type == "growEntity") {
        this.open_growEntity();
        return;
      }

      if (type == "comRoam") {
        this.open_comRoam();
        return;
      }
      if (type == "comHide") {
        this.open_comHide();
        return;
      }

      if (type == "spreadEntity") {
        this.open_spreadEntity();
        return;
      }

      if (type == "multiRoam") {
        this.open_multiRoam();
        return;
      }
    },
    open_multiRoam() {
      this.$dialog.open({
        id: "多漫游",
        title: "多漫游",
        theme: "feature-dialog",
        area: {
          height: "auto",
          width: "400px",
        },
        content: {
          type: "vue",
          subCom: multiRoam,
          subData: this.subData,
        },
      });
    },
    open_spreadEntity() {
      this.$dialog.open({
        id: "蔓延",
        title: "蔓延",
        theme: "feature-dialog",
        area: {
          height: "auto",
          width: "400px",
        },
        content: {
          type: "vue",
          subCom: spreadEntity,
          subData: this.subData,
        },
      });
    },
    open_comHide() {
      this.$dialog.open({
        id: "隐藏",
        title: "隐藏",
        theme: "feature-dialog",
        area: {
          height: "auto",
          width: "400px",
        },
        content: {
          type: "vue",
          subCom: comHide,
          subData: this.subData,
        },
      });
    },
    open_blinkEntity() {
      this.$dialog.open({
        id: "闪烁",
        title: "闪烁",
        theme: "feature-dialog",
        area: {
          height: "auto",
          width: "400px",
        },
        content: {
          type: "vue",
          subCom: blinkEntity,
          subData: this.subData,
        },
      });
    },

    open_growEntity() {
      this.$dialog.open({
        id: "生长",
        title: "生长",
        theme: "feature-dialog",
        area: {
          height: "auto",
          width: "400px",
        },
        content: {
          type: "vue",
          subCom: growEntity,
          subData: this.subData,
        },
      });
    },

    open_comRoam() {
      this.$dialog.open({
        id: "漫游",
        title: "漫游",
        theme: "feature-dialog",
        area: {
          height: "auto",
          width: "400px",
        },
        content: {
          type: "vue",
          subCom: comRoam,
          subData: this.subData,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.g-group {
  display: flex;
  flex-direction: column;
}

.g-msg {
  color: #e6a23c;
  font-size: 12px;
  padding: 2px 0 0 10px;
}

.f-group {
  color: #ffffff;
  font-size: 12px;
  flex: auto;

  .inner {
    padding: 0 10px;

    .list {
      display: grid;
      grid-gap: 10px;
      justify-items: center;
      align-items: center;
      grid-template-columns: repeat(4, 1fr);

      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        width: 100%;
        border: 1px #c3c3c3 dashed;
        padding: 6px 0;

        .icon {
          width: 20px;
          height: 20px;
        }
      }

      .item.selected {
        border-color: #e6a23c;
        .icon {
          color: #e6a23c;
        }

        .title {
          color: #e6a23c;
        }
      }
    }

    .text {
      text-align: left;
      padding: 10px 0;
      color: #e6a23c;
    }
  }
}
</style>
